
import React from 'react';
import {FlowRender} from "../../flow-render";
import {AccountState, WLF_ADMIN} from "../../constants";
import { Text } from "../../prm/text";
import { Name } from "../../prm/name";
import { sprintf } from "sprintf-js";
import { DivGrid } from "../../../client/components/div-grid";
import { role_0_source_of_funds } from "../source-of-funds";
import { industry_of_occupation as industry_map } from "../../TDA_constants.json";
import { occupation as occupation_map } from "../../TDA_constants.json";
import { investments_knowledge, investment_focus, current_investments } from "../risk_1";
import { invest_start_amt, contribute_yes_no, contribute_cadence,
  contribute_amt } from "../risk_2";
import { dollarToString } from "../../currency-utils";
import {
  is_ugma as is_ugma_f, role_signer_mapping,
  is_ira_rollover as is_ira_rollover_f, role_titles
} from "../../onboarding-utils";
import { calc_roles_old, CLIENT_SIGNER, JOINT_SIGNER } from "../../onboarding-utils";
import { FileChooser } from "../../../client/components/file-dialog";
import {deep_copy} from "../../js-utils";
import {
  adminSendConfirmationEmail,
  signingDone,
  signNewEnvelope,
  signSetUserInfo
} from "../../../client/onboarding/actions";
import {DwollaCustomerStates} from "../../dwolla/constants";
import {Action, Spinner, TextLoading} from "../../../client/funcs/utils";
import { InitialAllocation, bad_allocation } from "../../onboarding-shared/widgets/allocation";
import {ProxyDocumentDelivery, SigningType} from "../../docusign-constants";
import {maybe_update, PersonalInfo, setup_personal_info_state} from "./personal-info";
import {RadioButton} from "../../prm/radio-button";
import {
  adminSetAccountState,
  adminSetInvestmentAccountType
} from "../../../client/components/SA_UserPortfolios/actions";
import {getRGB} from "../../color";

const upload_file = new Text(new Name("upload_file"));

const split = token => {
  if (!token || token.length === 0) {
    return null;
  }
  return token[0].split("|")[1];
};

const border_div_style = {
  marginTop: "2rem",
  borderTop: "1px solid black",
};

const bold_style = {
  display: "inline-block",
  verticalAlign: "top",
  fontWeight: "bold",
  width: "20%",
};

const data_style = {
  display: "inline-block",
};

const UPLOAD_STATE_FILE = "FILE";
const UPLOAD_STATE_UPLOAD = "UPLOAD";

const skip_signing = new RadioButton(
  new Name("skip_signing"),
  [
    new Name("skip", "Skip"),
  ]);
skip_signing.do_checkbox = true;

class Summary extends FlowRender {

  constructor() {
    super(null, [upload_file, skip_signing]);
    this.fileDialog = null;
    this.fileObject = null;
    this.read_only = false;
    this.title_text = "New Account Summary";
    this.url = "summary";
  }

  init(componentState, appState, component) {
    super.init(componentState, appState);
    componentState.upload_state = UPLOAD_STATE_FILE;
    componentState.show_file_dialog = false;
    componentState.is_signing = false;
    componentState.show_debug = false;
    componentState.is_set_sign_info = false;
    Object.assign(componentState, setup_personal_info_state(component));
  };

  set_read_only = read_only => {
    this.read_only = read_only;
  };

  set_title_text = title_text => {
    this.title_text = title_text;
  };


  onNewProps = (component, newState, newProps) => {
    const curr_onboarding = component.getOnboardingData();
    const next_onboarding = component.getOnboardingData(newProps);
    if ('alloc' in curr_onboarding && !('alloc' in next_onboarding)) {
      // alloc was removed from the onboarding, call calcCategoryAllocation
      component.calcCategoryAllocation();
    }
  }

  toggleDebug = component => {
    component.setState({
      show_debug: !component.state.show_debug,
    })
  }

  onMount(component) {
    const num_signers = calc_roles_old(component.getOnboardingData()).length;

    component.props.refreshDwolla(component.getOnboardingIndex(), component.props.username);
    if (!component.hasOnboardingAlloc()) {
      component.calcCategoryAllocation();
    }

    if (component.props.location && component.props.location.search) {
      const search = component.props.location.search.substring(1);
      let terms = [];
      if (search.includes("&")) {
        terms = search.split("&");
      } else {
        terms.push(search);
      }

      if (terms.includes('signed') && num_signers === 2) {
        // We're arrived here from a signing, but have to do a second signing.
        signingDone(
          component.props.token,
          component.props.onboarding_token,
          component.getOnboardingIndex())
          .then(result => {
            const data = result.body.data;
            if (data.msg === 'SIGNED_USER' || data.msg === 'SIGNED_FIRST_USER') {
              component.props.setAccountState(
                data.account_state, component.getOnboardingIndex());

              if (data.files) {
                component.props.dataToStore(
                  { confirmation_email_files: data.files },
                  component.getOnboardingIndex(), component.props.username);
              }

            }
          })
      }
    }
  }

  setFileDialog = elem => {
    this.fileDialog = elem;
  };

  setFileObject = file => {
    this.fileObject = file;
  }

  header = text => {
    return (<div style={{ fontWeight: "800", fontSize: "1.5rem"}}>{text}</div>);
  };

  labelText = (label, text0, text1, width="40%", additionalContainerStyle={}, additionalTextStyle={}) => {
    const container_div = {
      marginTop: "1rem",
      ...additionalContainerStyle 
    };
    const style = Object.assign({}, bold_style);
    style.width = width;
    const text_style = { fontWeight: "400", ...additionalTextStyle };
    return (
      <div key={label} style={container_div}>
        <div style={style}><div style={{marginRight: "1rem", fontWeight: "bold"}}>{label}: </div></div>
        <div style={data_style}>
          <div style={text_style}>
            {text0}
          </div>
          { text1 && <div style={text_style}>{text1}</div> }
        </div>
      </div>
    )
  };

  renderUpload = component => {

    const style = {
      ...bold_style,
      paddingTop: "0.5rem",
      width: "20%",
    };
    const input_style = {
      ...bold_style,
      paddingTop: ".2rem",
      width: "50%",
    };
    const button_container = {
      ...bold_style,
      marginTop: "0.3rem",
      marginLeft: "2rem",
    };
    delete button_container.width;
    const button_text = component.state.upload_state === UPLOAD_STATE_FILE
      ? "Select File" : "Upload";

    const onButtonClick = () => {
      if (component.state.upload_state === UPLOAD_STATE_FILE) {
        component.setState({
          show_file_dialog: true,
        })
        this.fileDialog.show();
      } else {
        component.props.UploadFile(
          this.fileObject,
          component.getOnboardingIndex(),
          "bank_statements/" + this.fileObject.name);
      }
    };

    const onEdit = file => {
      if (file) {
        const newState = deep_copy(component.state);
        newState.upload_state = UPLOAD_STATE_UPLOAD;
        upload_file.setValue(newState, file.name);
        component.setState(newState);
        this.setFileObject(file);
      }
    }

    return (
      <div style={{ marginTop: "1rem"}}>
        <div style={style}>
          <div style={{fontWeight: "bold"}}>
            Latest Bank Statement:
          </div>
        </div>
        <div style={input_style}>
          { upload_file.renderInput(component, {width: "100%"}) }
        </div>
        <div style={button_container}>
          <Action onClick={onButtonClick}>
            <div style={{fontWeight: "bold"}}>
              {button_text}
            </div>
          </Action>
          <FileChooser ref={ this.setFileDialog } onChange={onEdit}/>
        </div>
      </div>
    );
  };

  renderTransferType = component => {
    const onboarding = component.getOnboardingData(component.props);
    const is_ira_rollover = is_ira_rollover_f(onboarding);
    const acct_type = split(onboarding.xfer_acct_type);
    const community_property_state = onboarding.transfer_community_property_state;
    const tennant_owner_pct = onboarding.xfer_tenant_owner_pct;
    const tennant_co_owner_pct = onboarding.xfer_tenant_co_owner_pct;
    const ugma_state = onboarding.xfer_ugma_state;
    const ugma_age = onboarding.xfer_age_menu;

    let text0 = null;
    let text1 = null;
    if (acct_type === 'individual') {
      text0 = "Individual";
    } else if (acct_type === 'joint_spouse') {
      text0 = "Joint Spouse";
      text1 = "Community Property State " + community_property_state;
    } else if (acct_type === "joint_tenants") {
      text0 = "Joint Tennants with rights for survivorship";
    } else if (acct_type === "tenants_common") {
      text0 = "Tennants In Common";
      text1 = sprintf("%s %% owner - %s %% co-owner",
        tennant_owner_pct, tennant_co_owner_pct);
    } else if (acct_type === "ira_rollover") {
      const xfer_ira_type = split(onboarding.xfer_ira_type);

      if (xfer_ira_type === "traditional_ira") {
        text0 = "Traditional IRA";
      } else if (xfer_ira_type === "rollover_ira") {
        text0 = "Rollover IRA";
      } else if (xfer_ira_type === "roth_ira") {
        text0 = "Roth IRA";
      } else {
        text0 = "UNKNOWN";
      }
    } else if (acct_type === "trust") {
      text0 = "UGMA Trust account for a minor";
      text1 = sprintf("State %s age %s", ugma_state, ugma_age);
    }

    const data = component.getOnboardingData(component.props);

    return (
      <div style={is_ira_rollover ? {} : border_div_style}>
        { !is_ira_rollover && <div style={{fontSize: "1.5rem"}}>Account Transfer</div> }
        { !is_ira_rollover && this.labelText("Account Type", text0, text1) }
        { this.labelText(is_ira_rollover ? "Transfer Title" : "Account Title", data["acct_title"]) }
        { this.labelText(is_ira_rollover ? "Transfer Account" : "Account Number", data["acct_number"]) }
        { this.labelText("Address", data["firm_address_0"], data["firm_address_1"]) }
        { this.labelText("Phone Number", data["firm_phone"]) }
        { /* !this.read_only && this.renderUpload(component) */ }
      </div>
    )
  };

  renderAccountType = component => {
    const onboarding = component.getOnboardingData(component.props);
    const invest_for = split(onboarding.invest_for);
    const invest_type = onboarding.invest_type;
    const ira_type = split(onboarding.ira_type);
    const comm_property_state = onboarding.community_property_state;
    const tenants = split(onboarding.tenants);
    const tenants_owner_pct = onboarding.tenant_owner_pct;
    const tenants_co_owner_pct = onboarding.tenant_co_owner_pct;
    const ugma_state = onboarding.ugma_state_menu_2;
    const child_age = onboarding.child_age_menu;

    let text0 = null;
    let text1 = null;

    if (invest_for === 'standard_invest_0' || invest_for === 'standard_invest_1') {
      if (invest_type === "individual") {
        text0 = "Individual";
      } else if (invest_type === "spouse") {
        text0 = "Joint Spouse";
        text1 = "Married Community Property State " + comm_property_state;
      } else if (invest_type === "tenants_in_common") {
        if (tenants === 'joint') {
          text0 = "Joint Tenants with Rights of Surviorship";
        } else if (tenants === 'tenants') {
          text0 = "Tenants in Common";
          text1 = sprintf("%s %% Owner  %s %% Co-Owner",
            tenants_owner_pct, tenants_co_owner_pct);
        }
      }
    } else if (invest_for === "IRA") {
      if (ira_type === "traditional") {
        text0 = "Traditional IRA";
      } else if (ira_type === "roth") {
        text0 = "Roth IRA";
      }
    } else if (invest_for === "trust") {
      text0 = "UGMA Trust Account";
      text1 = sprintf("State %s Age %s", ugma_state, child_age);
    } else if (invest_for === "IRA_rollover") {
      const rollover_type = split(onboarding.rollover_acct_type);
      if (rollover_type === "401k") {
        text0 = "Rollover -> 401k";
      } else if (rollover_type === "simple_ira") {
        text0 = "Rollover -> Simple IRA";
      }
    }

    const accountTypeWidth = "40%"
    const accountTypeContainerStyle = {
        display: "flex"
    }
    const accountTypeTextStyle = {
        flex: "1 1 auto"
    }

    return (
      <div style={border_div_style}>
        { this.header("New Account") }
        { this.labelText("Account Type", text0, text1, accountTypeWidth, accountTypeContainerStyle, accountTypeTextStyle) }
      </div>
    )
  };

  renderIncomeNetWorth = component => {

    const onboarding = component.getOnboardingData();
    if (!onboarding.role_0_income || !onboarding.role_0_net_worth) {
      return null;
    }

    const role_0_income = dollarToString(onboarding.role_0_income, true);
    const role_0_net_worth = dollarToString(onboarding.role_0_net_worth);
    const row = [
      {
        width: 1,
        elem: (
          <div>
            { this.header("Income") }
            <span style={{fontWeight: "bold"}}>{role_0_income}</span>
          </div>
        ),
      },
      {
        width: 1,
        elem: (
          <div>
            { this.header("Net Worth") }
            <span style={{fontWeight: "bold"}}>{role_0_net_worth}</span>
          </div>
        ),
      }
    ];

    return (
      <div style={border_div_style}>
        <DivGrid items={[row]} />
      </div>
    );
  };

  renderSourceOfFunds = component => {
    const onboarding = component.getOnboardingData(component.props);
    const value = Array.isArray(onboarding.role_0_source_of_funds)
      && onboarding.role_0_source_of_funds[0];
    const label = value
      ? role_0_source_of_funds.buttonList.find(button => button.id === value).label
      : "UNDEFINED";
    const is_other = label === "Other";
    const role_0_other_source = onboarding.role_0_other_source;

    const span_0_style = {
      fontWeight: "bold",
    }
    const span_1_style = {
      ...span_0_style,
      paddingLeft: "1rem",
      fontWeight: "normal",
    };
    return (
      <div style={border_div_style}>
        { this.header("Source Of Funds") }
        <div>
          <span style={span_0_style}>{label}</span>
          { is_other && <span style={span_1_style}>{role_0_other_source}</span> }
        </div>
      </div>
    )
  };

  renderEmploymentColumn = (component, index, role) => {
    const prefix = sprintf("employment_%d", index);
    const width = "40%";
    const onboarding = component.getOnboardingData(component.props, 0);
    const status = split(onboarding[prefix + "_status"]);
    const employer_name = onboarding[prefix + "_employer_name"];
    const industry_of_occupation =
      industry_map[onboarding[prefix + "_industry_of_occupation"]];
    const occupation =
      occupation_map[onboarding[prefix + "_occupation"]];
    return (
      <div style={{marginRight: "1rem"}}>
        { this.labelText("Status", status, null, width) }
        { this.labelText("Employer Name", employer_name, null, width)}
        { this.labelText("Industry", industry_of_occupation, null, width) }
        { this.labelText("Occupation", occupation, null, width) }
      </div>
    );
  };

  renderEmployment = component => {
    //const roles = this.calc_roles(component);
    const roles = calc_roles_old(component.getOnboardingData());

    const row = roles.map((role, index) => {
      return {
        width: 1,
        elem: this.renderEmploymentColumn(component, index, role),
      }
    });

    return (
      <div style={border_div_style}>
        { this.header("Employment Information") }
        <DivGrid items={[row]} />
      </div>
    )
  };

  renderGoals = component => {
    const onboarding = component.getOnboardingData(component.props);
    const text_0 =
      sprintf("I'd like to start accessing my funds in %s years.",
        onboarding.access_funds_years);
    const text_1 =
      sprintf("After accessing funds, I'd like to continue spending for %s years after that.",
        onboarding.spend_funds_years);
    return (
      <div style={border_div_style}>
        { this.header("Goals") }
        <div>{text_0}</div>
        <div>{text_1}</div>
      </div>
    )
  };

  renderRisk = component => {
    const onboarding = component.getOnboardingData(component.props, 0);
    if (Object.keys(onboarding).length === 0) {
      return null;
    }

    const get_buttons = (prm) => {
      const buttons = prm.getAppButtons(onboarding);
      if (buttons.length === 0) {
        return "UNDEFINED";
      }
      return buttons[0].label;
    }

    const ik_text = get_buttons(investments_knowledge);
    const when_text = get_buttons(investment_focus);
    const investments = current_investments.getAppButtons(onboarding);
    let invest_text = null;
    if (investments.length === 0) {
      invest_text = "NONE;"
    } else {
      invest_text = investments.map(button => button.label).join(", ");
    }

    const bold_style = {
      fontWeight: "600",
    }
    const label_style = {
      paddingBottom: "0.1rem",
    }

    return (
      <div style={border_div_style}>
        { this.header("Risk") }

        <div style={label_style}>{investments_knowledge.name.label}</div>
        <div style={bold_style}>{ik_text}</div>

        <div style={label_style}>{investment_focus.name.label}</div>
        <div style={bold_style}>{when_text}</div>

        <div style={label_style}>{current_investments.name.label}</div>
        <div style={bold_style}>{invest_text}</div>

      </div>
    )
  }

  renderInvestment = component => {
    const onboarding = component.getOnboardingData(component.props);
    if (!onboarding.contribute_yes_no) {
      return null;
    }

    const label_style = {
      paddingBottom: "0.1rem",
    };
    const bold_style = {
      fontWeight: "600",
    };
    const start_amt = dollarToString(
      parseInt(onboarding.invest_start_amt, 10));
    const yes_no_text = contribute_yes_no.getAppButtons(onboarding)[0].label;

    const contribute = contribute_yes_no.getAppValues(onboarding, true)[0] === 'yes';

    const cadence_text = contribute_cadence.getAppLabel(onboarding);

    const amt_text = contribute
      ? dollarToString(parseInt(onboarding.contribute_amt, 10))
      : null;

    return (
      <div style={border_div_style}>
        { this.header("Investment") }

        <div style={label_style}>{invest_start_amt.name.label}</div>
        <div style={bold_style}>{start_amt}</div>

        <div style={label_style}>{contribute_yes_no.name.label}</div>
        <div style={bold_style}>{yes_no_text}</div>

        { contribute && <div style={label_style}>How often:</div> }
        { contribute && <div style={bold_style}>{cadence_text}</div> }

        { contribute && <div style={label_style}>{contribute_amt.name.label}</div> }
        { contribute && <div style={bold_style}>{amt_text}</div> }
      </div>
    )
  }

  renderCrypto = component => {
    const onboarding = component.getOnboardingData(component.props);
    const do_crypto = split(onboarding.crypto_invest) === "yes";

    let crypto_line;
    if (do_crypto) {
      crypto_line = sprintf("Yes, up to %f%%", onboarding.crypto_amt);
    } else {
      crypto_line = "No";
    }
    const bold_style = {
      fontWeight: "bold",
    }
    return (
      <div style={border_div_style}>
        { this.header("Crypto")}
        <div style={{display: "flex"}}>
          <div style={{ flex: "1"}}>
            <div>Invest in Crytocurrent assets?</div>
            <div style={bold_style}>{crypto_line}</div>
          </div>
          <div style={{flex: "1"}}/>
        </div>
        <div style={{height: "2rem"}}/>
      </div>
    )
  }

  onSignClick = (component, signer) => () => {
    const onboarding = component.getOnboardingData();
    const num_roles = role_titles(onboarding).length;
    component.docusign_processing = true;
    maybe_update(component, num_roles)
      .then(() => {

        if (skip_signing.isItemClicked(0, component.state)) {
          signSetUserInfo(
            component.props.token, component.props.onboarding_token,
            component.getOnboardingIndex(), component.props.username)
            .then(() => {
              const url = component.getSigningDoneEndpoint();
              component.props.navigatePath(url);
            })
        } else {
          component.beginSigning(signer, true);
        }
      })
  };

  onClearEnvelope = component => () => {
    component.props.clearOnboardingItem(
      component.getOnboardingIndex(),
      ["envelope_id", "envelope_signed"]);
  };

  renderCustomerIssue = component => {

    let text = "There was an issue processing your personal information. please contact ";
    const email = "support@cleveralpha.com";
    const title = "Customer Verification Issue";
    const elem = (
      <span>{text}<a href={email}>{email}</a></span>
    )
    const title_text_style = { display: "flex", justifyContent: "center", fontSize: "2.5rem" };

    return (
      <div>
        <div align={"center"} style={{paddingTop: "1rem"}}>
          <div style={title_text_style}>{title}</div>
        </div>
        <div style={{paddingTop: "2rem", paddingBottom: "2rem" }}>
          <div style={{fontSize: "1.5rem"}}>{elem}</div>
        </div>
      </div>
    )
  }

  maybeRenderInitialAllocation = component => {
    const onboarding = component.getOnboardingData(component.props);
    const has_alloc = "alloc" in onboarding;
    const text = "Given your goals and comfort level with risk your initial allocation "
      + "will be into these investments";
    const msg = has_alloc
      ? (<div align={"center"}>
          <span style={{fontSize: "1.5rem"}}>{text}</span>
        </div>) : null;
    const spinner = (
      <div align={"center"}>
        <Spinner size={"2rem"}/>
      </div>
    );

    if (has_alloc && bad_allocation(onboarding.alloc.alloc)) {
      return null;
    }

    return (
      <div>
        { this.renderTitle(component, "Initial Allocation", "80%", "952140976")}
        { msg }
        <div>
          { has_alloc && <InitialAllocation
            component={component}
            state={component.state}
            alloc={onboarding.alloc.alloc}
            client={component.props.client}/> }
          { !has_alloc && spinner }
        </div>
      </div>
    )
  };

  getAdminOnboardingUrl = component => {
    const is_wlf_admin = component.props.user.account_type === WLF_ADMIN;
    return is_wlf_admin
      ? "/wlf-admin/onboarding"
      : "/super-admin/user?view=all&wlf_id=cleveralpha-asset-management";
  }

  onSignProxyClick = component => () => {
    const has_envelope_id = !!component.getOnboardingData().envelope_id;

    const token = component.props.token;
    const username = component.props.username;
    const index = component.getOnboardingIndex();
    const onboarding = component.getOnboardingData();
    const delivery_type = onboarding.docusign_delivery_type;

    if (has_envelope_id) {

      if (delivery_type === ProxyDocumentDelivery.SIGNED) {
        // Signed
        adminSetAccountState(token, username, index, AccountState.SIGNED_PROXY).then();
        adminSetInvestmentAccountType(token, username, index).then();
      }

      // Navigate back to dashboard
      component.props.navigatePath(this.getAdminOnboardingUrl(component));
      return;
    }

    component.setState({ is_signing: true });
    signNewEnvelope(
      token,
      null, // This is proxy signing, no onboarding token
      index,
      component.getOnboardingData(),
      null,
      SigningType.EMAIL_SIGNING,
      username)
      .then(result => {
        component.setState({ is_signing: false });
        component.props.dataToStore(
          result.onboarding, index, username);
        if (result.onboarding.envelope_id && component.props.onEnvelopeSent) {
          component.props.onEnvelopeSent(username, index);
        }
      }
    )

  }
  renderSigningProxyButton = component => {
    const onboarding = component.getOnboardingData();

    if (onboarding.docusign_delivery_type === ProxyDocumentDelivery.NO_ENVELOPE
      || onboarding.electronic_signing_type ===  ProxyDocumentDelivery.NO_ENVELOPE) {
      const no_env_click = () => {
        component.setState({
          is_set_sign_info: true,
        })
        signSetUserInfo(
          component.props.token, null, component.getOnboardingIndex(),
          component.props.username)
        .then(() => {
          component.setState({
            is_set_sign_info: false,
          });
          adminSendConfirmationEmail(
            component.props.token,
            component.getOnboardingIndex(),
            true,
            component.props.username).then();
          component.props.navigatePath(this.getAdminOnboardingUrl(component));
        })
      }

      return (
        <div align={"center"}>
          <div style={{margin: "1rem"}}>
            No Envelope Needed
          </div>
          <Action onClick={no_env_click}>
            <TextLoading
              label={"Click to activate account"}
              loading={component.state.is_set_sign_info}/>
          </Action>
        </div>
      )
    } else {
      const has_envelope_id = !!onboarding.envelope_id;
      const delivery_type = onboarding.docusign_delivery_type;
      const text = has_envelope_id ? "Back to Dashboard" : "Send Documents";
      const sent_div = (
        <div align={"center"} style={{margin: "2rem"}}>
          Documents Sent!
        </div>
      )
      return (
        <div align={"center"}>
          { has_envelope_id && delivery_type === ProxyDocumentDelivery.MAIL_OUT && sent_div }
          <Action
            onClick={this.onSignProxyClick(component)}>
            <TextLoading
              loading={component.state.is_signing}
              label={text}/>
          </Action>
        </div>
      )
    }
  }

  renderSigningButtons = component => {
    const onboarding = component.getOnboardingData(component.props);
    let customer_verified = true;
    if (!this.read_only) {
      const dwolla = component.getDwollaData(0);
      customer_verified = dwolla
        && dwolla.customer
        && dwolla.customer.state === DwollaCustomerStates.VERIFIED;
    }

    const client = component.props.client;
    const buttonColor = getRGB(client.color.sign_on_button);
    const button_style = {
      fontWeight: "600",
      padding: "1rem 2rem",
      backgroundColor: buttonColor,
      color: "#FFF",
    };

    const num_signers = role_signer_mapping(onboarding).length;
    const do_joint_button = num_signers === 2;
    const account_state = component.getAccountState();
    const disable_joint = account_state !== AccountState.HALF_SIGNED || !customer_verified;
    //const envelope_signed = !!onboarding.envelope_signed;
    const disable_client =
      (account_state !== AccountState.ONBOARDING && account_state !== AccountState.ONBOARDING_PROXY)
      || !customer_verified;
      //|| envelope_signed;

    const sign_button_label = component.props.username
      ? "Send Documents" : "Sign Documents";
    const button_id = component.props.username ? "send" : "sign";
    const loading = component.docusign_processing;
    let sign_button;

    if (component.navigating_to_docusign) {
      sign_button = (
        <div align={"center"} style={{marginTop: "2rem"}}>
          Navigating to Docusign for signature.
        </div>
      )
    } else {
      sign_button = (
        <div align={"center"} style={{marginTop: "2rem"}}>
          <Action
            id={button_id}
            style={button_style}
            onClick={this.onSignClick(component, CLIENT_SIGNER)}
            disabled={disable_client}>
            <TextLoading
              label={sign_button_label}
              loading={loading}/>
          </Action>
        </div>);
    }

    const joint_text = do_joint_button ?
      (<div align={"center"} style={{marginTop: "2rem"}}>
        <span style={{fontSize: "1.5rem"}}>
          You’ll sign first, then your joint signer will follow
        </span>
      </div>) : null;

    return (
      <div>
        { !this.read_only && joint_text }
        { !this.read_only && sign_button }
        { !this.read_only && do_joint_button && this.renderActionButton(
          "Sign Joint Documents", this.onSignClick(component, JOINT_SIGNER), disable_joint) }
      </div>
    )
  }

  maybeRenderSkipSigning = component => {
    if (!component.state.show_debug) {
      return null;
    }
    const container_style = {
      display: "flex",
      marginTop: "2rem",
    }

    return (
      <div style={container_style}>
        <div style={{flex: "2", fontWeight: "bold" }}>
          Skip Signing
        </div>
        <div style={{flex: "2"}}>
          { skip_signing.renderCheckbox(0, component) }
        </div>
        <div style={{flex: "1"}}/>
      </div>
    )
  }

  renderBody = component => {
    const onboarding = component.getOnboardingData(component.props);
    let customer_verified = true;
    if (!this.read_only) {
      const dwolla = component.getDwollaData(0);
      customer_verified = dwolla
        && dwolla.customer
        && dwolla.customer.state === DwollaCustomerStates.VERIFIED;
    }

    const is_loading = component.props.onboarding.loading || component.props.dwolla.loading;
    const is_ugma = is_ugma_f(onboarding);
    const is_proxy = !!component.props.username;
    const args = component.props.args;

    // Show the PersonalInfo if we're not a proxy onboarding, or if we're a proxy onboarding, only
    // this is the primary (first) account
    const show_personal_info = !is_proxy || (is_proxy && args.acct_index === '0');

    // If we're in proxy mode, view all the information.
    const simple_view = !component.props.username;
    return (
      <div>
        { !is_loading && !customer_verified && this.renderCustomerIssue(component) }
        { /* is_transfer && this.renderTransferType(component) */}
        { /* !is_transfer && this.renderAccountType(component) */ }
        { /* is_ira_rollover && this.renderTransferType(component) */ }
        { show_personal_info && <PersonalInfo component={component} state={component.state}/> }
        { !simple_view && this.renderIncomeNetWorth(component) }
        { !simple_view && this.renderSourceOfFunds(component) }
        { !simple_view && this.renderEmployment(component) }
        { !simple_view && !is_ugma && this.renderGoals(component) }
        { !simple_view && this.renderRisk(component) }
        { !simple_view && this.renderInvestment(component) }
        { !simple_view && this.renderCrypto(component) }
        <div style={border_div_style}/>
        { !is_proxy && this.renderSigningButtons(component) }
        { is_proxy && this.renderSigningProxyButton(component) }
        { this.maybeRenderSkipSigning(component) }
      </div>
    )
  };
  render = (component) => {

    return (
      <div>
        { this.renderSingleColumn(this.maybeRenderInitialAllocation(component), "75%") }
        {  this.renderSingleColumn(this.renderBody(component), "50%") }
      </div>
    );
  }
}

export { Summary };
